import { createSlice } from '@reduxjs/toolkit';

const getCartItemId = (item) => item?.cartId || item?.id || item?._id || item?.slug;

const initialState = {
  isCartOpen: false,
  cart: [],
  items: [],
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload;
    },

    addToCart: (state, action) => {
      const incomingItem = action.payload.item;
      const incomingId = getCartItemId(incomingItem);

      if (!incomingId) return;

      const existingItem = state.cart.find((item) => getCartItemId(item) === incomingId);

      if (existingItem) {
        existingItem.count += incomingItem.count || 1;
      } else {
        state.cart.push({
          ...incomingItem,
          cartId: incomingId,
          id: incomingId,
          count: incomingItem.count || 1,
        });
      }

      state.isCartOpen = true;
    },

    removeFromCart: (state, action) => {
      state.cart = state.cart.filter((item) => getCartItemId(item) !== action.payload.id);
    },

    increaseCount: (state, action) => {
      state.cart = state.cart.map((item) => {
        if (getCartItemId(item) === action.payload.id) {
          item.count += 1;
        }

        return item;
      });
    },

    decreaseCount: (state, action) => {
      state.cart = state.cart.map((item) => {
        if (getCartItemId(item) === action.payload.id && item.count > 1) {
          item.count -= 1;
        }

        return item;
      });
    },

    setIsCartOpen: (state, action) => {
      if (typeof action.payload === 'boolean') {
        state.isCartOpen = action.payload;
      } else {
        state.isCartOpen = !state.isCartOpen;
      }
    },
  },
});

export const {
  setItems,
  addToCart,
  removeFromCart,
  increaseCount,
  decreaseCount,
  setIsCartOpen,
} = cartSlice.actions;

export default cartSlice.reducer;